import { render } from 'react-dom';

import './style.scss';
import Style from './Style';
import SkypeButton from './SkypeButton';

// Business Card
document.addEventListener('DOMContentLoaded', () => {
	const allSkypeButton = document.querySelectorAll('.wp-block-sbb-skype-button');
	allSkypeButton.forEach(skypeButton => {
		const attributes = JSON.parse(skypeButton.dataset.attributes);

		render(<>
			<Style attributes={attributes} clientId={attributes.cId} />

			<SkypeButton attributes={attributes} clientId={attributes.cId} />
		</>, skypeButton);

		skypeButton?.removeAttribute('data-attributes');
	});
});